import api from '../../api'
import {LABORATORY_CREATE, LABORATORY_UPDATE, LABORATORY_DELETE,
        REACTION_CREATE, REACTION_UPDATE, REACTION_DELETE,
        STAIN_CREATE, STAIN_UPDATE, STAIN_DELETE,
        SLIDE_SERVICE_CREATE, SLIDE_SERVICE_UPDATE, SLIDE_SERVICE_DELETE} from '../mutations/available'
import {showApiError} from '../../helpers/notification'
import store from '../index'

export const laboratoryCreate = async ({commit, dispatch, state}, item) => {
  let created = null
  try {
    created = await api.laboratoryCreate(item)
    commit(LABORATORY_CREATE, created)
  } catch (e) {
    showApiError(store.$app, e, 'Unable to create item')
    console.log(`Unable to create item, details: ${JSON.stringify(e)}`)

    throw e
  }

  return created
}

export const laboratoryUpdate = async ({commit, dispatch, state}, item) => {
  let updated = null
  try {
    updated = await api.laboratoryUpdate(item)
    commit(LABORATORY_UPDATE, updated)
  } catch (e) {
    showApiError(store.$app, e, 'Unable to update item')
    console.log(`Unable to update item, details: ${JSON.stringify(e)}`)

    throw e
  }

  return updated
}

export const laboratoryDelete = async ({commit, dispatch, state}, item) => {
  try {
    await api.laboratoryDelete(item)
    commit(LABORATORY_DELETE, item)
  } catch (e) {
    showApiError(store.$app, e, 'Unable to delete item')
    console.log(`Unable to delete item, details: ${JSON.stringify(e)}`)

    throw e
  }

  return true
}

export const reactionCreate = async ({commit, dispatch, state}, item) => {
  let created = null
  try {
    created = await api.reactionCreate(item)
    commit(REACTION_CREATE, created)
  } catch (e) {
    showApiError(store.$app, e, 'Unable to create item')
    console.log(`Unable to create item, details: ${JSON.stringify(e)}`)

    throw e
  }

  return created
}

export const reactionUpdate = async ({commit, dispatch, state}, item) => {
  let updated = null
  try {
    updated = await api.reactionUpdate(item)
    commit(REACTION_UPDATE, updated)
  } catch (e) {
    showApiError(store.$app, e, 'Unable to update item')
    console.log(`Unable to update item, details: ${JSON.stringify(e)}`)

    throw e
  }

  return updated
}

export const reactionDelete = async ({commit, dispatch, state}, item) => {
  try {
    await api.reactionDelete(item)
    commit(REACTION_DELETE, item)
  } catch (e) {
    showApiError(store.$app, e, 'Unable to delete item')
    console.log(`Unable to delete item, details: ${JSON.stringify(e)}`)

    throw e
  }

  return true
}
export const stainCreate = async ({commit, dispatch, state}, item) => {
  let created = null
  try {
    created = await api.stainCreate(item)
    commit(STAIN_CREATE, created)
  } catch (e) {
    showApiError(store.$app, e, 'Unable to create item')
    console.log(`Unable to create item, details: ${JSON.stringify(e)}`)

    throw e
  }

  return created
}

export const stainUpdate = async ({commit, dispatch, state}, item) => {
  let updated = null
  try {
    updated = await api.stainUpdate(item)
    commit(STAIN_UPDATE, updated)
  } catch (e) {
    showApiError(store.$app, e, 'Unable to update item')
    console.log(`Unable to update item, details: ${JSON.stringify(e)}`)

    throw e
  }

  return updated
}

export const stainDelete = async ({commit, dispatch, state}, item) => {
  try {
    await api.stainDelete(item)
    commit(STAIN_DELETE, item)
  } catch (e) {
    showApiError(store.$app, e, 'Unable to delete item')
    console.log(`Unable to delete item, details: ${JSON.stringify(e)}`)

    throw e
  }

  return true
}

export const slideServiceCreate = async ({commit, dispatch, state}, item) => {
  let created = null
  try {
    created = await api.slideServiceCreate(item)
    commit(SLIDE_SERVICE_CREATE, created)
  } catch (e) {
    showApiError(store.$app, e, 'Unable to create item')
    console.log(`Unable to create item, details: ${JSON.stringify(e)}`)

    throw e
  }

  return created
}

export const slideServiceUpdate = async ({commit, dispatch, state}, item) => {
  let updated = null
  try {
    updated = await api.slideServiceUpdate(item)
    commit(SLIDE_SERVICE_UPDATE, updated)
  } catch (e) {
    showApiError(store.$app, e, 'Unable to update item')
    console.log(`Unable to update item, details: ${JSON.stringify(e)}`)

    throw e
  }

  return updated
}

export const slideServiceDelete = async ({commit, dispatch, state}, item) => {
  try {
    await api.slideServiceDelete(item)
    commit(SLIDE_SERVICE_DELETE, item)
  } catch (e) {
    showApiError(store.$app, e, 'Unable to delete item')
    console.log(`Unable to delete item, details: ${JSON.stringify(e)}`)

    throw e
  }

  return true
}


// WEBPACK FOOTER //
// ./src/store/actions/references.js